/**
 * Для отображения типов оплаты,
 * статусов смен и т.д.
 */

import http from '@/services/http'


/**
 * чтобы ничего не сломалось поставим такой mapper
 * @param {*} mappingArray [[key: string, value: string]]
 */
const getMappingObject = (mappingArray, isPaymentTypes) => {
  return mappingArray.reduce((acc, item, index) => {
    const accItem = {
      title: item[1],
      order_number: index
    }
    if (isPaymentTypes) {
      accItem.image = item[2]
    }
    acc[item[0]] = accItem
    return acc
  }, {})
}

export default {
  namespaced: true,
  state: {
    /**
     * {[string]: string; order_number: number | null}
     */
    paymentTypes: {},
    adminShiftStatuses: {},
    orderStatuses: {},
    adminRoles: {}
  },
  mutations: {
    SET_PAYMENT_TYPES(state, paymentTypes) {
      state.paymentTypes = getMappingObject(paymentTypes, true)
    },
    SET_ADMIN_SHIFT_STATUSES(state, adminShiftStatuses) {
      state.adminShiftStatuses = getMappingObject(adminShiftStatuses)
    },
    SET_ORDER_STATUSES(state, orderStatuses) {
      state.orderStatuses = getMappingObject(orderStatuses)
    },
    SET_ADMIN_ROLES(state, adminRoles) {
      state.adminRoles = getMappingObject(adminRoles)
    }
  },
  actions: {
    async getPaymentTypes({ commit }) {
      const res = await http.get('title_mappings/payment_types')
      commit('SET_PAYMENT_TYPES', res)
    },
    async getAdminShiftStatuses({ commit }) {
      const res = await http.get('title_mappings/admin_shift_statuses')
      commit('SET_ADMIN_SHIFT_STATUSES', res)
    },
    async getOrderStatuses({ commit }) {
      const res = await http.get('title_mappings/orders_statuses')
      commit('SET_ORDER_STATUSES', res)
    },
    async getAdminRoles({ commit }) {
      const res = await http.get('title_mappings/admin_roles')
      commit('SET_ADMIN_ROLES', res)
    },
    async getAllSharedData({ dispatch }) {
      /**
       * Пока без ролей,
       * роли используются только в welcome-screen
       * (но не факт, что не будут где-то еще использоваться)
       */
      dispatch('getPaymentTypes')
      dispatch('getAdminShiftStatuses')
      dispatch('getOrderStatuses')
    }
  }
}